/** Group of the fields whose identifier does not follow `<service>.<entity>.<field>`. */
export const OTHER_ENTITY = "";
const BUCKET_BY_OUTCOME = {
    WouldModify: "wouldModify",
    RetainedLegal: "retainedLegal",
    Refused: "refused",
    Untouched: "untouched",
};
function entityOf(fieldId) {
    const [path] = fieldId.split(":", 1);
    const segments = path.split(".");
    if (segments.length < 3 || segments.some((segment) => segment.length === 0)) {
        return OTHER_ENTITY;
    }
    return segments[1];
}
export function emptyCounts() {
    return { wouldModify: 0, retainedLegal: 0, refused: 0, untouched: 0, unknown: 0 };
}
export function groupTargetFieldsByEntity(fields) {
    const groups = new Map();
    for (const field of fields) {
        if (field.impactOutcome === null) {
            continue;
        }
        const entity = entityOf(field.fieldId);
        let group = groups.get(entity);
        if (!group) {
            group = { entity, counts: emptyCounts() };
            groups.set(entity, group);
        }
        group.counts[BUCKET_BY_OUTCOME[field.impactOutcome] ?? "unknown"] += 1;
    }
    return [...groups.values()];
}
